import {Component} from '@angular/core';
import {LoadingServiceProvider} from "../../providers/loading-service/loading-service";
import {AlertController, ViewController} from "ionic-angular";
import {ReadMode} from "angular-file-picker";
import {GlobalProvider} from "../../providers/global/global";


/**
 * Generated class for the AddFotoPopoverComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'add-foto-popover',
  templateUrl: 'add-foto-popover.html'
})
export class AddFotoPopoverComponent {
  public isBrowser: boolean = false;
  public readMode = ReadMode.dataURL;
  public acceptImageTypes: Array<string> = ['image/png','image/jpg', 'image/jpeg'];

  constructor(public viewCtrl: ViewController, private loadingController: LoadingServiceProvider, private globalProvider: GlobalProvider, private alertCtrl: AlertController) {
    this.isBrowser = this.globalProvider.isBrowser();
  }
  public close(typ): void {
    this.loadingController.present();
    this.viewCtrl.dismiss({type: typ});
  }

  public onFilePicked(data): void {
    if(this.acceptImageTypes.indexOf(data.type) !== -1){
      this.loadingController.present();
      this.viewCtrl.dismiss({type: 'filePicker', data: data});
    }
    else {
      //dataType not accept
      let alert = this.alertCtrl.create({
        title: 'Dateityp wird nicht Unterstützt',
        subTitle: 'Die von Ihnen ausgewählte Datei wird nicht Unterstützt. Bitte wählen Sie eine Datei folgenden Types aus: .png, .jpg oder .jpeg',
        buttons: ['OK']
      });
      alert.onDidDismiss(() => {
        this.viewCtrl.dismiss();
      })
      alert.present();
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/add-foto-popover/add-foto-popover.ts